import { useContext } from "react";

import { AuthContext } from "@/lib/auth/AuthProvider";
import type { CurrentUser } from "@/lib/auth/types";

/** Returns the authenticated user. Throws if used outside AuthProvider or
 *  while loading — callers should be rendered under a RequireAuth boundary. */
export function useUser(): CurrentUser {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useUser must be used within AuthProvider");
  if (!ctx.user) throw new Error("useUser called without an authenticated user");
  return ctx.user;
}

/** Lower-level: returns the raw context (may be loading or unauthenticated). */
export function useAuthState() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuthState must be used within AuthProvider");
  return ctx;
}
